import React, { useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { message } from "antd";
import { openInternalApp } from "@/utils/internalAppUrl";
import { getAccessToken } from "@/utils/sessionToken";
import { INTERNAL_APP_GROUP, InternalAppItem } from "./config";

interface InternalAppSectionProps {
  renderAppCard: (
    item: InternalAppItem,
    onClick: () => void
  ) => React.ReactNode;
}

const InternalAppSection: React.FC<InternalAppSectionProps> = ({
  renderAppCard,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleAppClick = (item: InternalAppItem): void => {
    const accessToken = getAccessToken();
    if (!accessToken) {
      message.error("登录已过期，请重新登录");
      return;
    }

    openInternalApp(item.href, accessToken);
  };

  const renderInternalAppCard = (item: InternalAppItem): React.ReactNode =>
    renderAppCard(item, () => handleAppClick(item));

  return (
    <section className="portal-section portal-section--internal">
      <div className="portal-section-header">
        <div className="portal-section-label">
          <span className="portal-section-title">
            {INTERNAL_APP_GROUP.label}
          </span>
        </div>
      </div>
      <div className="portal-internal-content">
        <div className="portal-section-cards portal-section-cards--featured">
          {INTERNAL_APP_GROUP.featuredItems.map(renderInternalAppCard)}
        </div>
        <button
          type="button"
          className="portal-internal-collapse"
          aria-expanded={isExpanded}
          aria-controls="other-internal-apps"
          onClick={() => setIsExpanded((value) => !value)}
        >
          <span>其他内网应用（{INTERNAL_APP_GROUP.otherItems.length}）</span>
          <DownOutlined
            className={`portal-collapse-arrow${
              isExpanded ? " portal-collapse-arrow--open" : ""
            }`}
          />
        </button>
        {isExpanded && (
          <div
            id="other-internal-apps"
            className="portal-section-cards portal-section-cards--muted"
          >
            {INTERNAL_APP_GROUP.otherItems.map(renderInternalAppCard)}
          </div>
        )}
      </div>
    </section>
  );
};

export default InternalAppSection;
